import React, { useContext, useState } from 'react';
import { Project, StateContext } from '../../StateContext';
import {
    Modal,
    Button,
    Box,
    TextField,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
} from '@mui/material';
import { editMechanicCall } from '../../Services/APICalls/apicalls';
import { boxStyle } from '../Projects/styles';
import { MechanicTypes, getMechanicTypeLabel } from '../../Services/types';
import { useLanguage } from '../../Services/LanguageContext';

interface PProps {
    about: string;
    name: string;
    id: number;
}

const EditMechanic = (props: PProps) => {
    const [mechanicName, setMechanicName] = useState(props.name);
    const [about, setAbout] = useState(props.about);
    const [open, setOpen] = useState(false);
    const [type, setType] = useState<string | number>(MechanicTypes[0].value);
    const { t, language } = useLanguage();

    const { loginData, setLoginData } = useContext<any>(StateContext);

    const editMechanicHandler = () => {
        editMechanicCall(props.id, mechanicName, about, type, setLoginData);
        setOpen(false);
    };

    return (
        <React.Fragment>
            <Button variant='outlined' onClick={() => setOpen(true)}>
                {t('edit')}
            </Button>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
            >
                <Box style={boxStyle as any}>
                    <form
                        onSubmit={editMechanicHandler}
                        action='#'
                        className='flex flex-col items-center gap-3'
                        style={{ width: '100%' }}
                    >
                        <TextField
                            type='text'
                            variant='outlined'
                            label={t('mechanic')}
                            value={mechanicName}
                            fullWidth
                            onChange={(x) => setMechanicName(x.target.value)}
                        />
                        <FormControl fullWidth>
                            <InputLabel id='mechanic-type-select-label'>
                                {t('type')}
                            </InputLabel>
                            <Select
                                label={t('type')}
                                labelId='mechanic-type-select-label'
                                id='mechanic-type-select'
                                value={type}
                                onChange={(x) => setType(x.target.value)}
                            >
                                {MechanicTypes.map((type) => (
                                    <MenuItem
                                        key={type.value}
                                        value={type.value}
                                    >
                                        {getMechanicTypeLabel(type.value, language)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <TextField
                            id='filled-multiline-static'
                            label={t('description')}
                            multiline
                            rows={4}
                            defaultValue={t('typeRemarksHere')}
                            variant='outlined'
                            fullWidth
                            value={about}
                            onChange={(x) => setAbout(x.target.value)}
                        />
                        <button style={{ width: '100%' }}>{t('edit')}</button>
                    </form>
                </Box>
            </Modal>
        </React.Fragment>
    );
};

export default EditMechanic;
